export async function initiateWithdrawDeposit(args) {
    const { spaceDapp, depositIds, signer, smartAccount } = args;
    if (!spaceDapp?.baseRegistry) {
        throw new Error('BaseRegistry not found');
    }
    const callDataArray = depositIds.map((depositId) => spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('initiateWithdraw', [depositId]));
    const toAddressArray = Array(depositIds.length).fill(spaceDapp.config.addresses.baseRegistry);
    return smartAccount.sendUserOp({
        toAddress: toAddressArray,
        callData: callDataArray,
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
